import React from 'react';
import { Form, FormCheckProps } from 'react-bootstrap';
import { useCheckboxGroup } from './CheckboxGroupContext';

export type CheckboxVariantSize = 'sm' | 'xl';
export type CheckboxChangeEvent = React.ChangeEvent<HTMLInputElement>;

export type CheckboxProps = FormCheckProps & {
  name?: string;
  label?: string;
  value: string;
  className?: string;
  variant?: CheckboxVariantSize;
  onChange?: React.ChangeEventHandler;
  isCheckBoxButton?: boolean;
};

const Checkbox: React.FC<CheckboxProps> = ({
  id,
  name: nameProp,
  label,
  disabled,
  checked: checkedProp,
  value,
  className,
  onChange,
  variant,
  onMouseDown,
  isCheckBoxButton = false,
  ...props
}) => {
  const groupContext = useCheckboxGroup();
  let name = nameProp;
  let checked = checkedProp;

  const handleOnMouseDown = (event: React.MouseEvent<HTMLInputElement>) => {
    onMouseDown && onMouseDown(event);
  };

  const handleOnChange = (event: CheckboxChangeEvent) => {
    if (disabled) {
      return;
    }
    groupContext.onChange && groupContext.onChange(event);
    onChange && onChange(event);
  };

  if (groupContext) {
    if (typeof checked === 'undefined') {
      checked =
        value && groupContext.value
          ? groupContext.value.includes(value)
          : false;
    }
    if (typeof name === 'undefined') {
      name = groupContext.name;
    }
  }

  return (
    <Form.Check
      type={'checkbox'}
      {...props}
      className={`${className ? className : ''} checkbox-custom ${
        variant ? ` checkbox-custom--${variant}` : ''
      } ${isCheckBoxButton ? 'checkbox-button' : ''} ${(isCheckBoxButton && checked) ? 'checkbox-button--checked' : ''}`}
      id={id}
      label={label}
      tabIndex={0}
    >
      <Form.Check.Input
        type={'checkbox'}
        name={name}
        checked={checked}
        onChange={handleOnChange}
        disabled={disabled}
        value={value}
        onMouseDown={handleOnMouseDown}
      />
      {label && <Form.Check.Label>{label}</Form.Check.Label>}
    </Form.Check>
  );
};

export default Checkbox;
